import LongButton from "./LongWidgetButton";
import Prompt from "../../WidgetInterface/Prompt/Prompt";
import React from "react";
import SideButton from "./Sidebutton";
import WidgetIcon from "./WidgetIcon";
import { createUseStyles } from "react-jss";
import { eventTypes } from "../../../lib/analytics";
import { isMobile } from "../../../lib/utils";
import widgetIconStyles from "./WidgetIconStyles.js";

const useStyles = createUseStyles(widgetIconStyles);

export default ({
  isOpen,
  sendEvent,
  prompt,
  setPrompt,
  onPromptSuggestionClick,
  specialButton,
  customWidgetPosition,
  numberOfUnreadMessages,
  customWidgetImage,
  addUserAction,
  customWidgetStyle,
  enableMinimize,
}) => {
  const styles = useStyles();
  const renderSpecialButton = (specialButton) => {
    if (specialButton.name === "sideButton") {
      return (
        <SideButton
          addUserAction={addUserAction}
          customWidgetImage={customWidgetImage}
          text={specialButton.text}
        />
      );
    }
    if (specialButton.name === "longButton") {
      return (
        <LongButton
          addUserAction={addUserAction}
          customAvatar={customWidgetImage}
          title={specialButton.title}
          text={specialButton.text}
          customPosition={specialButton.customPosition}
          showAvatarOnly={specialButton.showAvatarOnly}
        />
      );
    }
  };

  return !isOpen ? (
    <div
      className={styles.widgetIconContainer}
      style={customWidgetPosition ? customWidgetPosition : {}}
    >
      {specialButton ? (
        renderSpecialButton(specialButton)
      ) : (
        <>
          <Prompt
            {...prompt}
            onSuggestionClick={onPromptSuggestionClick}
            customWidgetStyle={customWidgetStyle}
            onClose={() => {
              setPrompt(null);
              sendEvent(eventTypes.PROMPT_CLOSED, {});
            }}
          />
          <WidgetIcon
            addUserAction={addUserAction}
            numberOfUnreadMessages={numberOfUnreadMessages}
            customWidgetImage={customWidgetImage}
            customWidgetStyle={customWidgetStyle}
            allowMinimize={
              !(prompt && prompt.text) && enableMinimize && isMobile()
            }
            sendEvent={sendEvent}
          />
        </>
      )}
    </div>
  ) : null;
};
